import type { Product } from "./types";

/** The customer-facing price is the lowest published variant price, or base price. */
export function currentProductPrice(product: Pick<Product, "variants" | "basePrice">): number {
  const prices = product.variants
    .map((variant) => variant.price)
    .filter((price) => Number.isFinite(price) && price > 0);
  return prices.length ? Math.min(...prices) : Number(product.basePrice) || 0;
}

/** A real discount is derived from the price fields, not a curated homepage list. */
export function isProductDiscounted(product: Pick<Product, "variants" | "basePrice" | "oldPrice" | "demo">): boolean {
  const currentPrice = currentProductPrice(product);
  return !product.demo && currentPrice > 0 && Number(product.oldPrice) > currentPrice;
}
